module.exports = __webpack_public_path__ + "static/media/paint5.02c0b087.jpg";